
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'cardForm': {'display': `flex`,'flexDirection': `column`,},'fullWidthInput': {'width': `100%`,'margin': `8px 0`,},'dividedColumn': {'display': `flex`,'justifyContent': `space-between`,},'halfWidthInput': {'margin': `8px 0`,'width': `49%`,},'cancelButton': {'width': `25%`,'marginRight': `15px`,},'saveCardButton': {'width': `25%`,},'halfWidthEnd': {'display': `flex`,'justifyContent': `flex-end`,},
        
      };
    };
  